<div class="layout-wrapper layout-content-navbar">
    <div class="layout-container">
      <!-- Side Navigation -->
      <app-side-nav></app-side-nav>
      
      <!-- Layout container -->
      <div class="layout-page">
        <!-- Content Wrapper -->
        <div class="content-wrapper">
            <div class="container-xxl flex-grow-1 container-p-y">
                <div>
                    <button type="button" class="btn btn" (click)="goBack()" style="color: blue;" >
                        <img src="assets/img/icons/back.png" alt="Back" style="width: 16px; height: 16px; margin-right: 5px; color: blue;"> Back
                    </button>
                </div>
              <!-- Page Header -->
              <h4 class="py-3 mb-4"><span class="text-muted fw-light">Study /</span> Study View</h4>
        
                <!-- Study Details Section -->
                <div class="study-details-container">
                    <!-- Study Header -->
                    <div class="study-header">
                        <div class="study-detail">
                            <p><strong>Study Details</strong></p>
                            <p><strong>Manager Name:</strong> {{ userInfo.name }}</p>
                            <p><strong>Start Date:</strong> {{ studyInfo.date_assigned }}</p>
                            <p><strong>Study Name:</strong> {{ studyInfo.study_name }}</p>
                        </div>
                        <div class="study-location">
                            <p><strong>Site Location:</strong> {{ userInfo.site_location }}</p>
                            <p><strong>End Date:</strong> {{ studyInfo.completion_date }}</p>
                            <p><strong>Status:</strong> {{ studyInfo.study_status }}</p>
                        </div>
                    </div>
                
                <!-- Study Grid Section -->
                <div class="study-grid">
            
                    <div class="grid-box">
                        <div class="box-header">
                            <!-- Study CDA Link -->
                            <a target="_blank" class="box-header link-warning" href="javascript:void(0)" 
                             [routerLink]="['/study-crc-edit', this.routeParams.id]" 
                             [queryParams]="{selectedOption: 1}">
                             Study CDA
                            </a>
                
                            <!-- View Study CDA Modal Button -->
                            <button class="btn btn-info btn-sm btn-custom" [ngClass]="studycda ? 'has-data' : 'no-data'" (mouseover)="openModal('studyCda')">View</button>
                        </div>
                    </div>
  
                    <!-- Modal for Study CDA -->
                    <div class="modal fade" id="studyCdaModal" tabindex="-1" role="dialog" aria-labelledby="studyCdaModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="studyCdaModalLabel">Study CDA Details</h5>
                                </div>
                                <div class="modal-body">
                                    <table class="table">
                                    <thead>
                                        <tr>
                                        <th><strong>Status</strong></th>
                                        <th><strong>Reason</strong></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                        <td>{{ studycda?.status }}</td>
                                        <td>{{ studycda?.status == 'Comment' ? studycda?.comment : studycda?.reason }}</td>
                                        </tr>
                                    </tbody>
                                    </table>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- CTA Section -->
                    <div class="grid-box">
                        <div class="box-header">
                            <!-- CTA Link -->
                            <a target="_blank" class="link-warning" href="javascript:void(0)" 
                            [routerLink]="['/study-crc-edit', this.routeParams.id]" 
                            [queryParams]="{selectedOption: 5}">
                            CTA
                            </a>

                            <!-- View CTA Modal Button -->
                            <button class="btn btn-info btn-sm btn-custom" [ngClass]="CTA && CTA.length > 0 ? 'has-data' : 'no-data'" (mouseover)="openModal('cta')">View</button>
                        </div>

                        <!-- Optional Box Content for CTA Details (commented out but provided) -->
                        <!-- 
                        <div class="box-content">
                        <div class="row">
                        <div class="col-md-3">
                            <strong>Name</strong>
                        </div>
                        <div class="col-md-3">
                            <strong>Status</strong>
                        </div>
                        <div class="col-md-6">
                            <strong>Reason/Link/Comment</strong>
                        </div>
                        </div>
                        <div *ngFor="let ctaItem of CTA" class="row">
                        <div class="col-md-3">
                            {{ctaItem?.name}}
                        </div>
                        <div class="col-md-3">
                            {{ctaItem?.status}}
                        </div>
                        <div class="col-md-6">
                            {{ctaItem?.status == 'Comment' ? ctaItem?.comment : ctaItem?.value}}
                        </div>
                        </div>
                        </div>
                        -->

                    </div>

                    <!-- Modal for CTA -->
                    <div class="modal fade" id="ctaModal" tabindex="-1" role="dialog" aria-labelledby="ctaModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="ctaModalLabel">CTA Details</h5>
                                </div>
                                <div class="modal-body">
                                    <table class="table">
                                    <thead>
                                        <tr>
                                        <th><strong>Name</strong></th>
                                        <th><strong>Status</strong></th>
                                        <th><strong>Reason/Link/Comment</strong></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let ctaItem of CTA">
                                        <td>{{ctaItem?.name}}</td>
                                        <td>{{ctaItem?.status}}</td>
                                        <td class="scroll-container">{{ctaItem?.status == 'Comment' ? ctaItem?.comment : ctaItem?.value}}</td>
                                        </tr>
                                    </tbody>
                                    </table>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Site Feasibility Section -->
                    <div class="grid-box">
                        <div class="box-header">
                            <!-- Site Feasibility Link -->
                            <a target="_blank" class="link-warning" href="javascript:void(0)" 
                                [routerLink]="['/study-crc-edit', this.routeParams.id]" 
                                [queryParams]="{selectedOption: 2}">
                                Site Feasibility
                            </a>
                        
                            <!-- View Site Feasibility Modal Button -->
                            <button class="btn btn-info btn-sm btn-custom" [ngClass]="studyfeasibility ? 'has-data' : 'no-data'" (mouseover)="openModal('siteFeasibility')">View</button>
                        </div>
                    
                        <!-- Optional Box Content for Site Feasibility Details (commented out but provided) -->
                        <!--
                        <div class="box-content">
                        <div class="row">
                            <div class="col-md-6">
                            <strong>Status</strong><br>{{studyfeasibility?.status}}
                            </div>
                            <div class="col-md-6">
                            <strong>Reason</strong><br>{{studyfeasibility?.status == 'Comment' ? studyfeasibility?.comment : studyfeasibility?.reason}}
                            </div>
                        </div>
                        </div>
                        -->
                    
                    </div>
                    
                    <!-- Modal for Site Feasibility -->
                    <div class="modal fade" id="siteFeasibilityModal" tabindex="-1" role="dialog" aria-labelledby="siteFeasibilityModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="siteFeasibilityModalLabel">Site Feasibility Details</h5>
                                </div>
                                    <div class="modal-body">
                                        <!-- Site Feasibility Details -->
                                        <p><strong>Status:</strong> {{studyfeasibility?.status}}</p>
                                        <p><strong>Reason:</strong> {{studyfeasibility?.status == 'Comment' ? studyfeasibility?.comment : studyfeasibility?.reason}}</p>
                                    
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <!-- Document Submission to PI Section -->
                    <div class="grid-box">
                        <div class="box-header">
                            <!-- Document Submission to PI Link -->
                            <a target="_blank" class="link-warning" href="javascript:void(0)" 
                            [routerLink]="['/study-crc-edit', this.routeParams.id]" 
                            [queryParams]="{selectedOption: 9}">
                            Document Submission to PI
                            </a>

                            <!-- View Document Submission Modal Button -->
                            <button class="btn btn-info btn-sm btn-custom" [ngClass]="document_sumbmission_to_pi && document_sumbmission_to_pi.length > 0 ? 'has-data' : 'no-data'"  (mouseover)="openModal('documentSubmission')">View</button>
                        </div>

                        <!-- Optional Box Content for Document Submission (commented out but provided) -->
                        <!--
                        <div class="box-content">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th><strong>Sub Site Activities</strong></th>
                                            <th><strong>Status</strong></th>
                                            <th><strong>Reason</strong></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let doc of document_sumbmission_to_pi">
                                            <td>{{ doc.name }}</td>
                                            <td>{{ doc.status }}</td>
                                            <td>{{ doc.status == 'Comment' ? doc.comment : doc.reason }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        -->
                    </div>

                    <!-- Modal for Document Submission to PI -->
                    <div class="modal fade" id="documentSubmissionModal" tabindex="-1" role="dialog" aria-labelledby="documentSubmissionModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="documentSubmissionModalLabel">Document Submission Details</h5>
                                </div>
                                <div class="modal-body">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>Sub Site Activities</th>
                                                <th>Status</th>
                                                <th>Reason</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let doc of document_sumbmission_to_pi">
                                                <td>{{ doc.name }}</td>
                                                <td>{{ doc.status }}</td>
                                                <td>{{ doc.status == 'Comment' ? doc.comment : doc.reason }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                                    
                    <!-- EC Submission Section -->
                    <div class="grid-box">
                        <div class="box-header">
                            <!-- EC Submission Link -->
                            <a target="_blank" class="link-warning" href="javascript:void(0)" 
                            [routerLink]="['/study-crc-edit', this.routeParams.id]" 
                            [queryParams]="{selectedOption: 13}">
                            EC Submission
                            </a>

                            <!-- View EC Submission Modal Button -->
                            <button class="btn btn-info btn-sm btn-custom" [ngClass]="EC_Submission && EC_Submission.length > 0 ? 'has-data' : 'no-data'" (mouseover)="openModal('ecSubmission')">View</button>
                        </div>

                        <!-- Optional Box Content for EC Submission (commented out but provided) -->
                        <!--
                        <div class="box-content">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th><strong>Activity Name</strong></th>
                                            <th><strong>Activity Status</strong></th>
                                            <th><strong>Activity Reason</strong></th>
                                            <th><strong>Date</strong></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let doc of EC_Submission">
                                            <td>{{ doc.name }}</td>
                                            <td>{{ doc.status ? doc.status : (doc.value == 1 ? 'Yes' : 'No') }}</td>
                                            <td>{{ doc.status == 'Comment' ? doc.comment : doc.reason }}</td>
                                            <td>{{ doc.date }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        -->
                    </div>

                    <!-- EC Submission Modal -->
                    <div class="modal fade" id="ecSubmissionModal" tabindex="-1" role="dialog" aria-labelledby="ecSubmissionModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="ecSubmissionModalLabel">EC Submission Details</h5>
                                </div>
                                <div class="modal-body">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>Activity Name</th>
                                                <th>Activity Status</th>
                                                <th>Reason</th>
                                                <th>Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let doc of EC_Submission">
                                                <td>{{ doc.name }}</td>
                                                <td>{{ doc.status ? doc.status : (doc.value == 1 ? 'Yes' : 'No') }}</td>
                                                <td>{{ doc.status == 'Comment' ? doc.comment : doc.reason }}</td>
                                                <td>{{ doc.date }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    <!-- IP-NONIP Section -->
                    <div class="grid-box">
                        <div class="box-header">
                            <!-- IP-NONIP Link -->
                            <a target="_blank" class="link-warning" href="javascript:void(0)" 
                            [routerLink]="['/study-crc-edit', this.routeParams.id]" 
                            [queryParams]="{selectedOption: 15}">IP-NONIP</a>

                            <!-- View IP-NONIP Modal Button -->
                            <button class="btn btn-info btn-sm btn-custom" [ngClass]="studyip && studyip.length > 0 ? 'has-data' : 'no-data'" (mouseover)="openModal('ipNonIp')">View</button>
                        </div>

                        <!-- Optional Box Content for IP-NONIP (commented out but provided) -->
                        <!--
                        <div class="box-content">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th><strong>Sub Site Activities</strong></th>
                                            <th><strong>Status</strong></th>
                                            <th><strong>Reason</strong></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let doc of studyip">
                                            <td>{{ doc.name }}</td>
                                            <td>{{ doc.status ? doc.status : (doc.value == '1' ? 'Yes' : 'No') }}</td>
                                            <td>{{ doc.status == 'Comment' ? doc.comment : doc.reason }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        -->
                    </div>

                    <!-- IP-NONIP Modal -->
                    <div class="modal fade" id="ipNonIpModal" tabindex="-1" role="dialog" aria-labelledby="ipNonIpModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="ipNonIpModalLabel">IP-NONIP Details</h5>
                                </div>
                                <div class="modal-body">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>Sub Site Activities</th>
                                                <th>Status</th>
                                                <th>Value</th>
                                                <th>Reason</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let doc of studyip">
                                                <td>{{ doc.name }}</td>
                                                <td>{{ doc.status }}</td>
                                                <td class="scroll-container">{{ doc.value }}</td>
                                                <!-- Uncomment if reason needed -->
                                                <td>{{ doc.status == 'Comment' ? doc.comment : doc.reason }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                                    
                    <!-- SITE INITIATION VISIT DONE Section -->
                    <div class="grid-box">
                        <div class="box-header">
                            <!-- Link to Edit SITE INITIATION VISIT DONE -->
                            <a target="_blank" class="link-warning" href="javascript:void(0)" 
                            [routerLink]="['/study-crc-edit', this.routeParams.id]" 
                            [queryParams]="{selectedOption: 16}">SITE INITIATION VISIT DONE</a>

                            <!-- View Button for SITE INITIATION VISIT DONE Modal -->
                            <button class="btn btn-info btn-sm btn-custom" [ngClass]="SITE_INITATION_VISIT_DONE && SITE_INITATION_VISIT_DONE.length> 0 ? 'has-data' : 'no-data'" (mouseover)="openModal('siteVisitDone')">View</button>
                        </div>

                        <!-- Optional Box Content for SITE INITIATION VISIT DONE (commented out but provided) -->
                        <!--
                        <div class="box-content">
                            <div class="row">
                                <div class="col-md-3"><strong>Name</strong></div>
                                <div class="col-md-3"><strong>Status</strong></div>
                                <div class="col-md-6"><strong>Reason/Comment</strong></div>
                            </div>
                            <div *ngFor="let ctaItem of SITE_INITATION_VISIT_DONE" class="row">
                                <div class="col-md-3">{{ctaItem?.name}}</div>
                                <div class="col-md-3">{{ctaItem?.status}}</div>
                                <div class="col-md-6">{{ctaItem?.status == 'Comment' ? ctaItem?.comment : ctaItem?.reason}}</div>
                            </div>
                        </div>
                        -->
                    </div>

                    <!-- SITE INITIATION VISIT DONE Modal -->
                    <div class="modal fade" id="siteVisitDoneModal" tabindex="-1" role="dialog" aria-labelledby="siteVisitDoneModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="siteVisitDoneModalLabel">SITE INITIATION VISIT DONE Details</h5>
                                </div>
                                <div class="modal-body">
                                    <!-- Details Table for SITE INITIATION VISIT DONE -->
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th><strong>Name</strong></th>
                                                <th><strong>Status</strong></th>
                                                <th><strong>Reason/Comment</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let ctaItem of SITE_INITATION_VISIT_DONE">
                                                <td>{{ ctaItem?.name }}</td>
                                                <td>{{ ctaItem?.status }}</td>
                                                <td>{{ ctaItem?.status == 'Comment' ? ctaItem?.comment : ctaItem?.reason }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="grid-box">
                        <div class="box-header">
                          <a target="_blank" class="link-warning" href="javascript:void(0)" 
                             [routerLink]="['/study-crc-edit', this.routeParams.id]" [queryParams]="{selectedOption: 17}">
                             Running Status
                          </a>
                          <button class="btn btn-info btn-sm btn-custom" [ngClass]="RUNNING_STATUS  && RUNNING_STATUS.length > 0 ? 'has-data' : 'no-data'" (mouseover)="openModal('runningStatus')">View</button>
                        </div>
                    
                        <!-- Uncommented Box Content for Running Status -->
                        <!--<div class="box-content">
                          <div class="row border" *ngFor="let activity of RUNNING_STATUS">
                            <div class="col-md-6">
                              <strong>Sub Site Activity</strong><br>
                              {{activity.name}}
                            </div>
                            <div class="col-md-6" *ngIf="activity.status">
                              <strong>Status</strong><br>{{activity.status}}
                            </div>
                            <div class="col-md-6" *ngIf="activity.comment || activity.reason">
                              <strong>Reason</strong><br>{{ activity.status == 'Comment' ? activity.comment : activity.reason }}
                            </div>
                            <div class="col-md-6" *ngIf="activity.value">
                              <strong>Value</strong><br>{{ activity.value == '1' ? 'Yes' : 'No' }}
                            </div>
                            <div class="col-md-6" *ngIf="activity.input">
                              <strong>Input</strong><br>{{ activity.input }}
                            </div>
                            <div class="col-md-12" style="margin-left: 10px;">
                              <ng-container *ngIf="activity.sub_data">
                                <ng-container *ngIf="activity.id == 152">
                                  <ng-container *ngIf="activity.value == '1'; else inputField">
                                    <div class="row">
                                      <div class="col-md-6">
                                        <strong>SAE Reporting done to IEC (Y/N)</strong><br>
                                      </div>
                                      <div class="col-md-1">
                                        {{ activity.sub_data.input_1 == '1' ? 'Yes' : 'No' }}<br>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <strong>SAE Reporting done to CRO (Y/N)</strong><br>
                                      </div>
                                      <div class="col-md-1">
                                        {{ activity.sub_data.input_2 == '1' ? 'Yes' : 'No' }}<br>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <strong>SAE Initial report submitted to CRO and IEC (Y/N)</strong><br>
                                      </div>
                                      <div class="col-md-1">
                                        {{ activity.sub_data.input_3 == '1' ? 'Yes' : 'No' }}<br>
                                      </div>
                                    </div>
                                  </ng-container>
                                  <ng-template #inputField>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <strong>Input</strong><br>
                                      </div>
                                      <div class="col-md-1">
                                        {{ activity.sub_data.input_4 }}<br>
                                      </div>
                                    </div>
                                  </ng-template>
                                </ng-container>
                                <ng-container *ngIf="activity.id == 153">
                                  <div class="row">
                                    <div class="col-md-6">
                                      <strong>Input</strong><br>
                                    </div>
                                    <div class="col-md-6">
                                      {{ activity.sub_data.input_1 }}<br>
                                    </div>
                                  </div>
                                </ng-container>
                              </ng-container>
                            </div>
                          </div>
                        </div>-->
                    </div>
                    
                    <!-- Running Status Modal -->
                    <div class="modal fade" id="runningStatusModal" tabindex="-1" role="dialog">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">Running Status Details</h5>
                            </div>
                            <div class="modal-body">
                              <!-- Modal content for Running Status goes here -->
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th><strong>Sub Site Activity</strong></th>
                                    <th><strong>Status</strong></th>
                                    <th><strong>Reason</strong></th>
                                    <th><strong>Value</strong></th>
                                    <th><strong>Input</strong></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let activity of RUNNING_STATUS">
                                    <td>{{ activity.name }}</td>
                                    <td>{{ activity.status }}</td>
                                    <td>{{ activity.status == 'Comment' ? activity.comment : activity.reason }}</td>
                                    
                                    <td class="scroll-container">{{ activity.value }}</td>
                                      
                                        
                                      
                                                      
                                    <td>{{ activity.input }}</td>
                                  </tr>
                                </tbody>
                              </table>
                      
                              <div *ngFor="let activity of RUNNING_STATUS">
                                <ng-container *ngIf="activity.sub_data">
                                  <ng-container *ngIf="activity.id == 152">
                                    <div class="row">
                                      <div class="col-md-6">
                                        <strong>SAE Reporting done to IEC (Y/N)</strong><br>
                                      </div>
                                      <div class="col-md-1">
                                        {{ activity.sub_data.input_1 == '1' ? "Yes" : "No" }}<br>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <strong>SAE Reporting done to CRO (Y/N)</strong><br>
                                      </div>
                                      <div class="col-md-1">
                                        {{ activity.sub_data.input_2 == '1' ? "Yes" : "No" }}<br>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <strong>SAE Initial report submitted to CRO and IEC (Y/N)</strong><br>
                                      </div>
                                      <div class="col-md-1">
                                        {{ activity.sub_data.input_3 == '1' ? "Yes" : "No" }}<br>
                                      </div>
                                    </div>
                                  </ng-container>
                                  <ng-container *ngIf="activity.id == 153">
                                    <div class="row">
                                      <div class="col-md-6">
                                        <strong>Input</strong><br>
                                      </div>
                                      <div class="col-md-6">
                                        {{ activity.sub_data.input_1 }}<br>
                                      </div>
                                    </div>
                                  </ng-container>
                                </ng-container>
                              </div>
                            
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    

                    <div class="grid-box">
                        <div class="box-header">
                            <a target="_blank" class="link-warning" href="javascript:void(0)" 
                               [routerLink]="['/study-crc-edit', this.routeParams.id]" 
                               [queryParams]="{selectedOption: 18}">Data Entry</a>
                            
                            <!-- View button to open Data Entry modal -->
                            <button class="btn btn-info btn-sm btn-custom" [ngClass]="Data_Entry && Data_Entry.length > 0 ? 'has-data' : 'no-data'" (mouseover)="openModal('dataEntry')">View</button>
                        </div>
                        
                        <!--<div class="box-content">
                            <div class="row" *ngFor="let activity of Data_Entry">
                                <div class="col-md-4">
                                    <strong>Sub Site Activity</strong><br>
                                    {{activity.name}}
                                </div>
                                <div class="col-md-2">
                                    <strong>Status</strong><br>{{activity.status}}
                                </div>
                                <div class="col-md-3">
                                    <strong>Reason</strong><br> 
                                    {{ activity.status == 'Comment' ? activity.comment : activity.reason }}
                                </div>
                                <div class="col-md-2">
                                    <strong>Check Values</strong>
                                </div>
                            </div>
                        </div>-->
                    </div>
                    
                    <!-- Modal for Data Entry -->
                    <div class="modal fade" id="dataEntryModal" tabindex="-1" role="dialog" aria-labelledby="dataEntryModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="dataEntryModalLabel">Data Entry Details</h5>
                                </div>
                                <div class="modal-body">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th><strong>Sub Site Activity</strong></th>
                                                <th><strong>Status</strong></th>
                                                <th><strong>Reason</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let activity of Data_Entry">
                                                <td>{{activity.name}}</td>
                                                <td>{{activity.status}}</td>
                                                <td>{{activity.status == 'Comment' ? activity.comment : activity.reason}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    

                    <div class="grid-box">
                        <div class="box-header">
                            <a target="_blank" class="link-warning" href="javascript:void(0)" 
                               [routerLink]="['/study-crc-edit', this.routeParams.id]" 
                               [queryParams]="{selectedOption: 19}">CSR Submission</a>
                            
                            <!-- View button to open CSR Submission modal -->
                            <button class="btn btn-info btn-sm btn-custom" [ngClass]="studycsr && studycsr.length > 0 ? 'has-data' : 'no-data'" (mouseover)="openModal('csrSubmission')">View</button>
                        </div>
                        
                        <!--<div class="box-content">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th><strong>Sub Site Activities</strong></th>
                                            <th><strong>Status</strong></th>
                                            <th><strong>Reason</strong></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let doc of studycsr">
                                            <td>{{ doc.name }}</td>
                                            <td>{{ doc.status ? doc.status : (doc.value == '1' ? "Yes" : "No") }}</td>
                                            <td>{{ doc.status == 'Comment' ? doc.comment : doc.reason }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>-->
                    </div>
                    
                    <!-- Modal for CSR Submission -->
                    <div class="modal fade" id="csrSubmissionModal" tabindex="-1" role="dialog" aria-labelledby="csrSubmissionModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="csrSubmissionModalLabel">CSR Submission Details</h5>
                                </div>
                                <div class="modal-body">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th><strong>Sub Site Activities</strong></th>
                                                <th><strong>Status</strong></th>
                                                <th><strong>Reason</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let doc of studycsr">
                                                <td>{{ doc.name }}</td>
                                                <td>{{ doc.status ? doc.status : (doc.value == '1' ? "Yes" : "No") }}</td>
                                                <td>{{ doc.status == 'Comment' ? doc.comment : doc.reason }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                                    
                    <div class="grid-box">
                        <div class="box-header">
                            <!-- Existing Edit button -->
                            <a target="_blank" class="link-warning" href="javascript:void(0)" 
                               [routerLink]="['/study-crc-edit', this.routeParams.id]" 
                               [queryParams]="{selectedOption: 45}">CTRI Done</a>
                            
                            <!-- View button to open CTRI Done modal -->
                            <button class="btn btn-info btn-sm btn-custom" [ngClass]="CTRI_Done && CTRI_Done.length > 0 ? 'has-data' : 'no-data'" (mouseover)="openModal('ctriDone')">View</button>
                        </div>
                        
                        <!--<div class="box-content">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th><strong>Sub Site Activities</strong></th>
                                            <th><strong>Status</strong></th>
                                            <th><strong>Reason</strong></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let doc of CTRI_Done">
                                            <td>{{ doc.name }}</td>
                                            <td>{{ doc.status ? doc.status : (doc.value == '1' ? 'Yes' : 'No') }}</td>
                                            <td>{{ doc.status == 'Comment' ? doc.comment : doc.reason }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>-->
                    </div>
                    
                    <!-- Modal for CTRI Done -->
                    <div class="modal fade" id="ctriDoneModal" tabindex="-1" role="dialog" aria-labelledby="ctriDoneModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="ctriDoneModalLabel">CTRI Done Details</h5>
                                </div>
                                <div class="modal-body">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th><strong>Sub Site Activities</strong></th>
                                                <th><strong>Status</strong></th>
                                                <th><strong>Reason</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let doc of CTRI_Done">
                                                <td>{{ doc.name }}</td>
                                                <td>{{ doc.status ? doc.status : (doc.value == '1' ? 'Yes' : 'No') }}</td>
                                                <td>{{ doc.status == 'Comment' ? doc.comment : doc.reason }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                                        
                    <!-- close out Grid -->
                    <div class="grid-box">
                        <div class="box-header">
                            <!-- Existing Edit button -->
                            <a target="_blank" class="link-warning" href="javascript:void(0)" 
                            [routerLink]="['/study-crc-edit', this.routeParams.id]" 
                            [queryParams]="{selectedOption: 20}">Close Out</a>
                            
                            <!-- View button to open Close Out modal -->
                            <button class="btn btn-info btn-sm btn-custom" [ngClass]="Close_Out && Close_Out.length > 0 ? 'has-data' : 'no-data'" (mouseover)="openModal('closeOut')">View</button>
                        </div>
                        <!--<div class="box-content">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th><strong>Sub Site Activities</strong></th>
                                            <th><strong>Status</strong></th>
                                            <th><strong>Reason</strong></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let doc of Close_Out">
                                            <td>{{ doc.name }}</td>
                                            <td>{{ doc.status ? doc.status : (doc.value == '1' ? 'Yes' : 'No') }}</td>
                                            <td>{{ doc.status == 'Comment' ? doc.comment : doc.reason }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>-->
                    </div>

                    <!-- Modal for Close Out -->
                    <div class="modal fade" id="closeOutModal" tabindex="-1" role="dialog" aria-labelledby="closeOutModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="closeOutModalLabel">Close Out Details</h5>
                                </div>
                                <div class="modal-body">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th><strong>Sub Site Activities</strong></th>
                                                <th><strong>Status</strong></th>
                                                <th><strong>Reason</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let doc of Close_Out">
                                                <td>{{ doc.name }}</td>
                                                <td>{{ doc.status ? doc.status : (doc.value == '1' ? 'Yes' : 'No') }}</td>
                                                <td>{{ doc.status == 'Comment' ? doc.comment : doc.reason }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>                       
                </div>
            </div>
        </div>
    </div>
                    
                    <!-- hello -->


                    <!-- hello -->
                    <hr class="my-5" />
                </div>
                <div class="h555px row">
    
                </div>
                <!-- / Content -->
                <div class="content-backdrop fade"></div>
            </div>
            <!-- Content wrapper -->
        
        <!-- / Layout page -->
   

    <!-- Overlay -->
    <div class="layout-overlay layout-menu-toggle"></div>
